const SHARE_CACHE = 'pensamientos-share-target';
const SHARE_KEY = 'pending';

function urlsFromSharedText(value) {
  const text = String(value || '').trim();
  if (!text) return [];
  if (/^https?:\/\//i.test(text) && !/\s/.test(text)) return [text];
  return (text.match(/https?:\/\/[^\s<>"']+/g) || []).map((url) => url.replace(/[),;.\]]+$/g, ''));
}

async function takeSharedPhotos() {
  if (typeof caches === 'undefined') return { files: [], urls: [] };
  try {
    const cache = await caches.open(SHARE_CACHE);
    const response = await cache.match(SHARE_KEY);
    if (!response) return { files: [], urls: [] };
    await cache.delete(SHARE_KEY);
    const formData = await response.formData();
    const files = [];
    const urls = [];
    for (const [name, value] of formData.entries()) {
      if (typeof File !== 'undefined' && value instanceof File && value.size) {
        files.push(value);
        continue;
      }
      if (name === 'title' || name === 'text' || name === 'url') {
        urls.push(...urlsFromSharedText(value));
      }
    }
    return { files, urls: [...new Set(urls)] };
  } catch {
    return { files: [], urls: [] };
  }
}

module.exports = {
  SHARE_CACHE,
  SHARE_KEY,
  urlsFromSharedText,
  takeSharedPhotos,
};
